import barba from '@barba/core';
import { EventDispatcher } from './controllers/EventDispatcher.js';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/dist/ScrollTrigger';
import ScrollSmoother from 'gsap/dist/ScrollSmoother';
import MainNavigation from './components/MainNavigation.js';
import PageFlipController from './controllers/PageFlipController.js';
import './controllers/ResizeController.js';
import ContentVideoController from './controllers/ContentVideoController.js';
import SliderVideoController from './controllers/SliderVideoController.js';
import GlobalStore from './datastorage/GlobalStore.js';
import 'lazysizes';
import ContentButtonController from './controllers/ContentButtonController.js';
import ContentModuleController from './controllers/ContentModuleController.js';
import ContentAnimationController from './controllers/ContentAnimationController.js';

class Main {
    constructor() {
        this.div_Scroller = document.getElementById('scroller');
        this.myScroll = null;

        this.myMainNavigation = new MainNavigation();
        this.myPageFlipController = new PageFlipController();

        this.myContentVideoController = new ContentVideoController('.content-video-loop', GlobalStore.get('device'));
        this.mySliderVideoController = new SliderVideoController('.slider-video', GlobalStore.get('device'));

        this.myContentButtonController = new ContentButtonController();
        this.myContentModuleController = new ContentModuleController();

        this.myContentAnimationController = new ContentAnimationController();
    }

    disposeScrollTriggers() {}

    controllSmoothScroll() {}

    get sliderVideoController() {
        return this.mySliderVideoController;
    }
}

let myApp = null;

export function getApp() {
    if (!myApp) {
        myApp = new Main();
    }
    return myApp;
}

document.addEventListener('DOMContentLoaded', () => {
    getApp();
});
